import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { BLACK } from '../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../theme/fontConstants';

import { textFieldSx } from './formFieldStyles';

const OptionLabel = ({ labelKey, labelValues }) => LanguageConverterV2(labelKey, labelValues);

OptionLabel.propTypes = {
  labelKey: PropTypes.string.isRequired,
  labelValues: PropTypes.shape({}),
};

const SelectedValue = ({ options, value, placeholder }) => {
  const option = options.find((item) => item.value === value);
  if (!option) {
    return <span style={{ color: BLACK[60] }}>{placeholder}</span>;
  }
  return <OptionLabel labelKey={option.labelKey} labelValues={option.labelValues} />;
};

const optionValueType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
const optionShape = PropTypes.shape({
  value: optionValueType.isRequired,
  labelKey: PropTypes.string.isRequired,
  labelValues: PropTypes.shape({}),
});

SelectedValue.propTypes = {
  options: PropTypes.arrayOf(optionShape).isRequired,
  value: optionValueType,
  placeholder: PropTypes.string,
};

const SelectField = ({ id, value, options, onChange, ariaLabel, placeholder, testId }) => (
  <TextField
    id={id}
    select
    value={value}
    onChange={(event) => onChange(event.target.value)}
    SelectProps={{
      IconComponent: KeyboardArrowDownIcon,
      SelectDisplayProps: ariaLabel ? { 'aria-label': ariaLabel } : undefined,
      ...(placeholder !== undefined && {
        displayEmpty: true,
        renderValue: (selected) => (
          <SelectedValue options={options} value={selected} placeholder={placeholder} />
        ),
      }),
    }}
    {...{ inputProps: { 'data-testid': testId } }}
    sx={textFieldSx}
  >
    {options.map((option) => (
      <MenuItem
        key={option.value}
        value={option.value}
        sx={{ fontFamily: PRIMARY_FONT[400], fontSize: '14px' }}
      >
        <OptionLabel labelKey={option.labelKey} labelValues={option.labelValues} />
      </MenuItem>
    ))}
  </TextField>
);

SelectField.propTypes = {
  id: PropTypes.string,
  value: optionValueType.isRequired,
  options: PropTypes.arrayOf(optionShape).isRequired,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  placeholder: PropTypes.string,
  testId: PropTypes.string,
};

export default SelectField;
